import { INITIALIZE_APP } from '../constants';

export const initalizeApp = (data) => ({
    type: INITIALIZE_APP,
    payload: data,
});
